import React from 'react';
import { useData } from '@microsoft/teamsfx-react';
import { observer } from 'mobx-react-lite';
import { mergeClasses, Spinner, Text } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { useStore } from 'src/hooks/useStore';
import ThingsWorkingOnCard from 'src/components/organisms/things-working-on-card/ThingsWorkingOnCard';
import { useStyles } from './ThingsImWorkingOnSection.styles';

const ThingsImWorkingOnSection: React.FC = () => {
  const { activitiesStore } = useStore();
  const { loading, error, data: cardActivities } = useData(activitiesStore.loadCardActivities);
  const styles = useStyles();
  const containerPadding = isMobile ? styles.containerPaddingMobile : styles.containerPaddingDesktop;

  if (loading) return <Spinner />;
  if (error) throw error;
  if (!cardActivities) return null;

  const thingsWorkingOn = cardActivities.thingsIAmWorkingOn;
  if (thingsWorkingOn.length === 0) return null;

  const renderedCards = thingsWorkingOn.map((card, index) => {
    const cardAnnouncement = `${index + 1} of ${thingsWorkingOn.length}`;

    return <ThingsWorkingOnCard key={card.id} card={card} ariaLabel={cardAnnouncement} />;
  });

  return (
    <section aria-label="Things I’m working on">
      <div className={mergeClasses(styles.container, containerPadding)} data-testid="things-im-working-on-section">
        <div className={mergeClasses('grid-layout', styles.grid)}>
          <Text className={styles.title}>Things I'm working on</Text>

          {renderedCards}
        </div>
      </div>
    </section>
  );
};
export default observer(ThingsImWorkingOnSection);
